import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AsyncSelect from 'react-select/async';
import { suggestRegularShuttleDeparture } from '../../../../data/shared/api/api';
import cx from 'classnames';
import DepartureOptionContainer from './DepartureOptionContainer';
import DepartureValueContainer from './DepartureValueContainer';
import debounce from 'lodash/debounce';
import {withTranslation} from "react-i18next";
import i18n from "../../../../i18n";
import ComboBox from "../../components/form/ComboBox";
import PlaceOptionContainer from "../place_select/PlaceOptionContainer";
import {getPlace} from "../../../../data/booking/normalizers/stop";

class DepartureSelectContainer extends Component {
    static propTypes = {
        id: PropTypes.string,
        className: PropTypes.string,
        placeholder: PropTypes.string,
        autoload: PropTypes.bool,
        filters: PropTypes.object,
        value: PropTypes.any,
        onChange: PropTypes.func,
        onBlur: PropTypes.func,
        focused: PropTypes.bool,
        searchThrottleTime: PropTypes.number
    };

    static defaultProps = {
        id: null,
        autoload: false,
        placeholder: i18n.t('shared.tap_to_search'),
        value: null,
        focused: false,
        searchThrottleTime: 300,
        filters: {
            lines: [],
        },
        onChange: () => {},
        onBlur: () => {}
    };

    throttledSearch = null;
    state = {
        loading : false,
        options : []
    }

    constructor(props) {
        super(props);

        this.throttledSearch = debounce((input, callback) => {
            this.getOptions(input)
                .then((result) => callback( result))
                .catch((error) => callback(null));
        }, props.searchThrottleTime);
    }

    componentDidMount(){
        this.refresh()
    }

    refresh() {
        this.getOptions()
    }

    focus() {
        this.refs.select.focus();
    }

    handleChange(value) {
        this.props.onChange(value);
    }

    getOptions(input) {
        const { autoload, filters } = this.props;

        if (!input && !autoload) {
            return Promise.resolve({ options: [] });
        }
        this.setState({
            loading: true
        });
        return suggestRegularShuttleDeparture(input, filters)
            .then(response => response.json())
            .then(result => result.map(item => item))
            .then(options => {
                this.setState({
                    loading: false,
                    options
                });
                return options
            });
    }

    render() {
        const { id, value, placeholder} = this.props;
        const {loading, options} = this.state

        return <ComboBox
            id={id}
            loadOptions={::this.throttledSearch}
            placeholder={placeholder}
            clearable={true}
            value={value}
            onChange={::this.handleChange}
            components={{
                Option: PlaceOptionContainer
            }}
            labelCallback={getPlace}
            isLoading={loading}
            options={options}
        />
    }
}

export default withTranslation('translation', { withRef: true })(DepartureSelectContainer);